<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="페기물 처리결과" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn
                  v-if="editable"
                  label="저장"
                  icon="save" />
                <c-btn
                  v-if="editable"
                  label="삭제"
                  icon="remove" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-3">
                <c-plant required="true" type="edit" name="col0" v-model="data.col0" />
              </div>
              <div class="col-3">
                <c-field
                  :editable="editable"
                  :data="data"
                  deptValue="col2"
                  type="dept_user"
                  label="작성부서 & 작성자"
                  name="col3"
                  v-model="data.col3">
                </c-field>
              </div>
              <div class="col-3">
                <c-text
                  :editable="editable"
                  label="인계번호"
                  name="col5"
                  v-model="data.col5">
                </c-text>
              </div>
              <div class="col-3">
                <c-datepicker
                  label="인계일자"
                  name="col1"
                  v-model="data.col1"
                />
              </div>
              <div class="col-4">
                <c-select
                  :comboItems="wasteItems"
                  type="edit"
                  itemText="codeName"
                  itemValue="code"
                  name="col5"
                  label="폐기물 종류"
                  v-model="data.col5"
                ></c-select>
              </div>
              <div class="col-4">
                <c-text
                  :editable="editable"
                  label="위탁량"
                  name="col22"
                  v-model="data.col22">
                </c-text>
              </div>
              <div class="col-4">
                <c-select
                  codeGroupCd="WEIGHT_UNIT"
                  type="edit"
                  itemText="codeName"
                  itemValue="code"
                  name="col14"
                  label="단위"
                  v-model="data.col14"
                ></c-select>
              </div>
              <div class="col-4">
                <c-text
                  :editable="editable"
                  label="운반자명"
                  name="col5"
                  v-model="data.col5">
                </c-text>
              </div>
              <div class="col-4">
                <c-text
                  :editable="editable"
                  label="차량번호"
                  name="col22"
                  v-model="data.col22">
                </c-text>
              </div>
              <div class="col-4">
                <c-text
                  :editable="editable"
                  label="처리자명"
                  name="col14"
                  v-model="data.col14">
                </c-text>
              </div>
              <div class="col-4">
                <c-text
                  :editable="editable"
                  label="처리방법"
                  name="col14"
                  v-model="data.col14">
                </c-text>
              </div>
              <div class="col-4">
                <c-text
                  :editable="editable"
                  label="처리장소"
                  name="col14"
                  v-model="data.col14">
                </c-text>
              </div>
              <div class="col-4">
                <c-text
                  :editable="editable"
                  label="인계자명"
                  name="col14"
                  v-model="data.col14">
                </c-text>
              </div>
            </template>
          </c-card>
        </div>
      </div>
    </q-form>
  </div>
</template>
<script>
// import selectConfig from '@/js/selectConfig';
// import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'waste-report-detail',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          title: '',
          psiDocumentId: '',
          documentClassCd: '',
        }
      },
    },
    contentHeight: null,
  },
  data() {
    return {
      wasteItems: [
        { code: '1', codeName: '폐합성' },
        { code: '2', codeName: '폐내화물' },
        { code: '3', codeName: '폐파우더' },
        { code: '4', codeName: '폐수처리오니' },
      ],
      whetherItems: [
        { code: '1', codeName: '맑음' },
        { code: '2', codeName: '흐림' },
        { code: '3', codeName: '눈' },
        { code: '4', codeName: '비' },
        { code: '5', codeName: '구름' },
      ],
      data: {
        col0: '',
        col1: '2021-01-05',
        col2: 'D10003',
        col3: 'U000000018',
        col4: null,
        col5: null,
        col6: '1',
        col7: '',
        col11: '',
        col12: '',
        col13: '',
        col14: null,
        col15: '',
        col16: '',
        col17: '',
        col18: '',
        col19: '',
        col20: '',
        col21: '외부측정',
        col22: '',
      },
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 220);
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.getData();
    },
    getData() {
    },
  }
};
</script>